import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import NoPage from "./pages/NoPage";
import ScrollToTop from "./components/ScrollToTop";
import {
  defaultChannelId,
  defaultRegionIndex,
  defaultQualityIndex,
} from "./constants";
import {
  ChannelContext,
  RegionContext,
  QualityContext,
  PlayerProvider,
} from "./contexts";
import "./assets/styles/common.sass";
import "./assets/styles/responsive.sass";
import StaticPage from "./pages/StaticPage";
function App() {
  // State to hold the fetched content
  const [content, setContent] = useState(null);
  // State to manage loading status
  const [loading, setLoading] = useState(true);
  const [currentChannel, setCurrentChannel] = useState(defaultChannelId);
  const [regionIndex, setRegionIndex] = useState(defaultRegionIndex);
  const [qualityIndex, setQualityIndex] = useState(defaultQualityIndex);

  // useEffect to fetch content when the component mounts or language changes
  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        // Construct the path to the content file.
        // This path will now resolve directly to ~/my_proj/www/content/
        const response = await fetch(`/content/uk.json`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setContent(data); // Set the fetched content
      } catch (error) {
        console.error("Failed to fetch content:", error);
        setContent({
          title: "Error Loading Content",
          description: "Please check the console for more details.",
          callToAction: "Try Again",
        }); // Display a fallback error message
      } finally {
        setLoading(false); // Set loading to false after fetching (success or failure)
      }
    };

    fetchContent(); // Call the fetch function
  }, []);

  const channelRoutes =
    content && content.channels
      ? content.channels.map((channel, index) => (
          <Route key={index} path={channel.url} element={<Outlet />}>
            <Route
              key={index + "-default-region"}
              index
              element={
                <Home
                  setChannelId={setCurrentChannel}
                  channelId={channel.channelId}
                  content={content}
                  loading={loading}
                  regionIndex={regionIndex}
                  setRegionIndex={setRegionIndex}
                />
              }
            />
            {channel.ether && channel.ether.regions
              ? channel.ether.regions.map((region, regionIndex) => (
                  <Route
                    key={index + "-" + regionIndex}
                    path={region.url}
                    element={
                      <Home
                        setChannelId={setCurrentChannel}
                        channelId={channel.channelId}
                        content={content}
                        loading={loading}
                        regionIndex={regionIndex}
                        setRegionIndex={setRegionIndex}
                      />
                    }
                  />
                ))
              : null}
          </Route>
        ))
      : null;
  const staticRoutes =
    content && content.staticPages
      ? content.staticPages.map((page, index) => (
          <Route
            key={index}
            path={page.url}
            element={
              <StaticPage
                page={page}
                loading={loading}
                setLoading={setLoading}
              />
            }
          ></Route>
        ))
      : null;
  return (
    <PlayerProvider>
      <ChannelContext.Provider value={currentChannel}>
        <RegionContext.Provider value={regionIndex}>
          <QualityContext.Provider
            value={{
              qualityIndex: qualityIndex,
              setQualityIndex: setQualityIndex,
            }}
          >
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Layout content={content} />}>
                  <Route
                    index
                    element={
                      <Home
                        setChannelId={setCurrentChannel}
                        channelId={defaultChannelId}
                        content={content}
                        loading={loading}
                        regionIndex={regionIndex}
                        setRegionIndex={setRegionIndex}
                      />
                    }
                  />
                  {channelRoutes}
                  {staticRoutes}
                  <Route path="*" element={<NoPage content={content} />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </QualityContext.Provider>
        </RegionContext.Provider>
      </ChannelContext.Provider>
    </PlayerProvider>
  );
}

export default App;
